import dayjs from 'dayjs';

/** How the profile writes a date: the format the rest of the portal uses. */
const CHANGED_AT_FORMAT = 'DD/MM/YYYY';

/**
 * Formats the instant of the last password change, and returns nothing when there is none or when
 * what arrived cannot be read as a date.
 *
 * Nothing is the signal to hide the whole line. A date placeholder would claim the password was
 * changed at a moment nobody can name.
 */
export const formatChangedAt = (isoInstant?: string): string | undefined => {
  if (!isoInstant) return undefined;

  const parsed = dayjs(isoInstant);

  return parsed.isValid() ? parsed.format(CHANGED_AT_FORMAT) : undefined;
};
